import { render } from "./MarketSetting.vue?vue&type=template&id=4b5285dd&scoped=true"
import script from "@/assets/js/market.js?vue&type=script&lang=js&external"
export * from "@/assets/js/market.js?vue&type=script&lang=js&external"

import "@/assets/css/market.css?vue&type=style&index=0&id=4b5285dd&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5285dd"]])

export default __exports__